import styled from 'styled-components'

export const StepWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`
